<template>
  <b-modal
      id="modal-config-imagem"
      cancel-variant="outline-secondary"
      ok-title="Salvar"
      cancel-title="Cancelar"
      centered
      title="Configurar Imagem"
      size="xl"
      @ok="saveImagem(currentImage)"
      :ok-disabled="!currentImage.caminho"
      @cancel="resetData"
      @close="resetData"
      no-close-on-esc
      no-close-on-backdrop
  >
    <b-form>
      <b-row>
        <b-col cols="12" sm="6">
          <b-row class="justify-content-between ">
            <b-col cols="12" sm="6">
              <b-form-group>
                <validation-provider
                    #default="{ errors }"
                    name="Imagem principal"
                    rules="required"
                >
                  <b-form-checkbox
                      v-model="currentImage.imagem_principal"
                      :value="1"
                  >
                    Imagem principal
                  </b-form-checkbox>
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
            <b-col cols="12" sm="6">
              <b-form-group>
                <validation-provider
                    #default="{ errors }"
                    name="Exibe Cores"
                    rules="required"
                >
                  <b-form-checkbox
                      v-model="currentImage.exibe_cores"
                      :value="1"
                  >
                    Exibe Cores
                  </b-form-checkbox>
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>

            </b-col>
            <b-col cols="12" sm="6">
              <b-form-group label="Ordem">
                <validation-provider
                    #default="{ errors }"
                    name="Ordem"
                    rules="required"
                >
                  <b-form-select
                      v-model="currentImage.ordem"
                      text-field="text"
                      plain
                      :state="errors.length > 0 ? false:null"
                      value-field="value"
                      :options="[
                      { text: 'Selecione uma ordem', value: null, disabled: true },
                      { text: '1', value: 1 },
                      { text: '2', value: 2 },
                      { text: '3', value: 3 },
                      { text: '4', value: 4 },
                      { text: '5', value: 5 },
                  ]"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
            <b-col cols="12" sm="6">
              <b-form-group label="Embalagem">
                <validation-provider
                    #default="{ errors }"
                    name="Embalagem"
                    rules="required"
                >
                  <v-select
                      id="select-embalagem"
                      name="select-embalagem"
                      v-model="currentImage.cdn_embalag"
                      :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                      :class="{ 'border-danger border-round': errors.length > 0 }"
                      :options="embalagens"
                      label="des_embalag"
                      @search="listarEmbalagens"
                      key="cdn_embalag"
                      :loading="$store.getters['slsTemplateImagem/getIsLoading']"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
          </b-row>

          <b-row>
            <b-col cols="12" sm="6">
              <b-form-group label="Código da cor">
                <b-input-group>
                  <b-form-input placeholder="Digite o código da cor..." v-model="currentImage.cdn_cor"/>
                  <b-input-group-append>
                    <b-button variant="outline-primary" @click="searchCor()"v-b-tooltip.hover.top="'Definir cor'">
                      <feather-icon icon="CheckIcon"/>
                    </b-button>
                  </b-input-group-append>
                  <b-input-group-append>
                    <b-button variant="outline-primary" @click="showCollapse = !showCollapse" v-b-tooltip.hover.top="'Procurar cores'">
                      <feather-icon icon="SearchIcon" />
                    </b-button>
                  </b-input-group-append>
                </b-input-group>
              </b-form-group>
            </b-col>
            <b-col cols="12" sm="6" class="mt-2" align-self="end">
              <b-form-group
                  label-for="readOnlyInput"
              >
                <b-form-input
                    id="readOnlyInput"
                    v-model="nameColor"
                    :state="nameColor === 'Cor não encontrada' ? false:null"
                    :style="{
                      color: nameColor === 'Cor não encontrada' ? 'red' : 'black',
                    }"
                    readonly
                />
              </b-form-group>
            </b-col>

            <b-col cols="12" v-if="showCollapse">
              <app-collapse accordion>
                <app-collapse-item title="Lista de Cores" is-visible class-header-collapse="bg-gray">
                  <b-row>
                    <b-col cols="12">
                      <b-form-group label="Pesquisar">
                        <b-input-group>
                          <b-form-input placeholder="Digite o código da cor..." v-model="searchColor"
                            @input="listarCores()" />
                            <b-input-group-append>
                              <b-button variant="outline-danger" @click="searchColor = ''" v-b-tooltip.hover.top="'Limpar filto'">
                                <feather-icon icon="TrashIcon" />
                              </b-button>
                            </b-input-group-append>
                        </b-input-group>
                      </b-form-group>
                    </b-col>
                    <b-col cols="12">
                      <div v-if="!searchColor || searchColor.trim() === ''" class="text-center my-4">
                        <feather-icon icon="InfoIcon" size="24" class="text-muted mb-1"></feather-icon>
                        <h6 class="text-muted">Digite o código ou descrição da cor para pesquisar</h6>
                      </div>

                      <div v-else>
                        <b-table :busy="colorLoading" :striped="true" :bordered="true" :hover="true"
                          :responsive="true" ref="refTableColor" table-variant="secondary"
                          :per-page="paginationColor.perPage" :current-page="paginationColor.page"
                          :fields="fieldColos" :items="filterDataColor" responsive="sm" show-empty empty-text="Nenhuma cor encontrada">
                          <template #table-busy>
                            <div class="text-center my-2">
                              <b-spinner class="align-middle mr-1"></b-spinner>
                              <strong>Carregando...</strong>
                            </div>
                          </template>
                          <template #cell(index)="data">
                            {{ data.index + 1 }}
                          </template>

                          <template #cell(acoes)="data">
                            <b-button variant="primary" size="sm" @click="onSelectColor(data.item)">
                              Selecionar
                            </b-button>
                          </template>
                        </b-table>
                      </div>
                    </b-col>
                  </b-row>
                </app-collapse-item>
              </app-collapse>
            </b-col>

            <b-col cols="12">
              <b-form-group>
                <b-form-radio-group
                  v-model="uploadType"
                  :options="[
                    { text: 'Upload de Arquivo', value: 'file' },
                    { text: 'URL da Web', value: 'url' }
                  ]"
                  name="upload-type"
                ></b-form-radio-group>
              </b-form-group>

              <b-form-group>
                <b-form-file
                    v-if="uploadType === 'file'"
                    v-model="currentImage.caminho"
                    ref="refCaminho"
                    placeholder="Escolha um arquivo ou arraste-o aqui..."
                    drop-placeholder="Solte o arquivo aqui..."
                    accept="image/*"
                    @change="changeImg($event)"
                ></b-form-file>

                <b-form-input
                  v-else
                  v-model="imageUrl"
                  placeholder="Digite a URL da imagem..."
                  @input="loadImageFromUrl"
                ></b-form-input>
              </b-form-group>
            </b-col>

          </b-row>
        </b-col>
        <b-col cols="12" sm="6" class="d-flex justify-content-center">
          <b-form-group>
            <div class="molde-img">
              <b-img
                  v-if="imagemPresenter !== ''"
                  :src="imagemPresenter"
                  fluid
                  alt="Responsive image"
                  width="261"
                  height="350"
                  style="max-width: 350px; max-height: 261px;min-width: 350px; min-height: 261px;"
              />
              <b-img
                  v-else
                  :src="imagemPadrao"
                  fluid
                  alt="Responsive image"
                  width="261"
                  height="350"
                  style="max-width: 350px; max-height: 261px;min-width: 350px; min-height: 261px;"
              />
            </div>
          </b-form-group>
        </b-col>
      </b-row>
    </b-form>
  </b-modal>
</template>
<script>
import AppCollapse from '@core/components/app-collapse/AppCollapse.vue';
import AppCollapseItem from '@core/components/app-collapse/AppCollapseItem.vue';
import SlsEmbalagService from '@/services/SistemaDKP/sls-embalag.service';
import SlsCorService from '@/services/SistemaDKP/sls-cor.service';
import SlsTemplateImagemService from '@/services/SistemaDKP/sls-template-imagem.service';
import ToastificationContent from '@/@core/components/toastification/ToastificationContent.vue';
import { IMAGEM_PADRAO } from '@/utils/imagemUrl';

const slsEmbalagService = new SlsEmbalagService();
const slsCorService = new SlsCorService();
const slsTemplateImagemService = new SlsTemplateImagemService();
export default {
  components: {
    AppCollapse,
    AppCollapseItem,
  },
  props: {
    value: {
      type: Object,
      default: () => ({
        des_cor: null,
        des_marca: null,
      }),
    },
    marcaNome: {
      type: String,
      default: '',
    },
    familiaDescricao: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      imagemPadrao: IMAGEM_PADRAO,
      colorLoading: false,
      selected: [],
      ordem: null,
      imagemPresenter: null,
      embalagens: [],
      nameColor: null,
      searchColor: '',
      showCollapse: false,
      fieldColos: [
        { key: 'cdn_cor', label: 'Código da cor' },
        { key: 'des_cor', label: 'Descrição da cor' },
        { key: 'acoes', label: 'Ações' },
      ],
      dataColors: [],
      uploadType: 'file',
      imageUrl: '',
    };
  },
  computed: {
    filterDataColor() {
      return this.dataColors;
    },
    paginationColor: {
      get() {
        return this.$store.getters['slsCor/getFilters'];
      },
      set(val) {
        this.$store.commit('slsCor/setFilters', val);
      },
    },
    currentImage: {
      get() {
        if (this.value.cdn_cor && typeof this.value.cdn_cor === 'object') {
          this.cod_cor = this.value.cdn_cor.cdn_cor;
          this.nameColor = this.value.cdn_cor.des_cor;
        }
        if (this.value.caminho_base64) {
          this.imagemPresenter = this.value.caminho_base64;
        }
        return this.value;
      },
      set(value) {
        this.$emit('input', value);
      },
    },
  },
  methods: {
    resetData() {
      this.$emit('closeModal');
      this.currentImage = {
        imagem_principal: 0,
        exibe_cores: 0,
        ordem: null,
        des_marca: null,
        cdn_embalag: null,
        cdn_cor: null,
        caminho: null,
        caminho_base64: null,
        caminho_upload: null,
      };
      this.imagemPresenter = null;
      this.nameColor = null;
      this.searchColor = '';
      this.showCollapse = false;
      this.uploadType = 'file';
      this.imageUrl = '';
    },
    notifyWarning(message) {
      this.$toast({
        component: ToastificationContent,
        props: {
          title: 'Atencao',
          text: message,
          icon: 'AlertTriangleIcon',
          variant: 'warning',
        },
      });
    },
    async uploadImagem(file, nomeArquivo) {
      if (!this.marcaNome || !this.familiaDescricao) {
        this.notifyWarning('Selecione marca e referencia antes de enviar a imagem.');
        return;
      }

      this.$store.commit('slsTemplateImagem/setIsLoading', true);
      try {
        const response = await slsTemplateImagemService.uploadLocalImagem(
          file,
          this.marcaNome,
          this.familiaDescricao,
          nomeArquivo,
        );
        this.currentImage.caminho_upload = response.caminho;
      } catch (error) {
        this.currentImage.caminho = null;
        this.currentImage.caminho_upload = null;
        this.notifyWarning(error.message || 'Erro ao enviar a imagem.');
      } finally {
        this.$store.commit('slsTemplateImagem/setIsLoading', false);
      }
    },
    onSelectColor(cor) {
      this.currentImage.cdn_cor = cor.cdn_cor;
      this.nameColor = cor.des_cor;
      this.showCollapse = false;
    },
    async listarEmbalagens(term) {
      this.$store.commit('slsEmbalagem/setFilters', { q: term, ...this.$store.state.slsEmbalagem.filters });
      await slsEmbalagService.findAll().then((response) => {
        this.embalagens = response;
      });
    },
    async searchCor() {
      await slsCorService.index({ cdn_cor: this.currentImage.cdn_cor }).then((response) => {
        if (response.length === 0) return this.nameColor = 'Cor não encontrada';
        this.nameColor = response[0].des_cor;
      });
    },
    async listFilterCodCor(cdnCor) {
      await slsEmbalagService.findAll({ cdn_cor: cdnCor }).then((response) => {
        this.currentImage.cdn_embalag = response[0].cdn_embalag;
      });
    },
    saveImagem(e) {
      const caminhoFinal = this.currentImage.caminho_upload || this.currentImage.caminho;
      
      if (!caminhoFinal) {
        this.notifyWarning('Nenhuma imagem foi enviada. Tente novamente.');
        return;
      }

      this.$emit('addImagem', {
        ...e,
        cdn_cor: this.currentImage.cdn_cor,
        des_cor: this.nameColor,
        caminho: caminhoFinal,
      });
      this.resetData();
    },
    async listarCores(pagination) {
      if (!this.searchColor || this.searchColor.trim() === '') {
        this.dataColors = [];
        this.colorLoading = false;
        return;
      }

      this.colorLoading = true;
      try {
        const response = await slsCorService.index({
          q: this.searchColor,
          ...pagination,
        });
        this.dataColors = response;
      } catch (error) {
        console.error('Erro ao listar cores:', error);
      } finally {
        this.colorLoading = false;
      }
    },
    changeImg(event) {
      event.preventDefault();
      let file = null;
      if (event.dataTransfer) {
        file = event.dataTransfer.files[0];
      } else {
        file = event.target.files[0];
      }

      if (file) {
        this.currentImage.caminho_upload = null;
        const reader = new FileReader();
        reader.onload = (e) => {
          console.log('e.target.result', e.target.result);
          this.imagemPresenter = e.target.result;
          this.currentImage.caminho_base64 = e.target.result;
        };
        reader.readAsDataURL(file);
        this.uploadImagem(file, file.name);
      }
    },
    async loadImageFromUrl() {
      if (!this.imageUrl) return;

      try {
        this.currentImage.caminho_upload = null;
        const response = await fetch(this.imageUrl);
        const blob = await response.blob();

        const urlName = this.imageUrl.split('/').pop().split('?')[0] || 'image.jpg';
        const file = new File([blob], urlName, { type: blob.type });

        const reader = new FileReader();
        reader.onload = (e) => {
          this.imagemPresenter = e.target.result;
          this.currentImage.caminho_base64 = e.target.result;
        };
        reader.readAsDataURL(file);
        await this.uploadImagem(file, urlName);
      } catch (error) {
        console.error('Erro ao carregar imagem:', error);
        this.$toast({
          component: ToastificationContent,
          props: {
            title: 'Erro ao carregar a imagem.',
            text: 'Tente novamente ou aguarde a imagem ser cadastrada no sistema.',
            icon: 'AlertTriangleIcon',
            variant: 'warning',
          },
        });
      }
    },
  },
  async mounted() {
    await this.listarCores();
    await this.listarEmbalagens();
  },
};
</script>
